/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [image-box-small.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 04.02.20, 16:36
 */

import React, {useEffect, useRef} from 'react';
import {bindTooltip} from "../../actions/tippy-config";
import {getImageServerSmallUrl} from "../../actions/environment";
import {ImageHolder} from "../billboard-cover/cover-holder";
import {CancelIcon, EventAlertIcon} from "../navigation/icons/nav-icons";
import {useLanguage} from "../configuration/configuration";

export const ImageBoxBig = ({text, category, overlay, isToday, blocked, html, image, avatar, animated}) => {
    const imageRef = useRef(null);
    const tooltip = useRef(null);
    const Lang = useLanguage();

    useEffect(() => {
        if(html && imageRef.current) {
            tooltip.current = bindTooltip(imageRef.current, html,
                {placement: 'top', multiple: false, animation: 'shift-away'})
        }
        return () => {
            tooltip.current && tooltip.current.destroy();
        }
    }, [html]);

    return <div className='image-box-big' ref={imageRef}>
        {image && <div className='rectangular-cover'>
            <img className={`${blocked ? 'blocked-img' : 'thumb'} ${animated ? 'animated' : ''}`}
                 src={getImageServerSmallUrl(image)}/>
            {overlay && text && <div className='image-box-big-title'>
                <span className='image-box-big-title'>{text}</span>
            </div>}
            {isToday && <div className='image-box-today small'>
                <EventAlertIcon small className='mr-2'/>{Lang.info.status.isToday}</div>}
        </div>}
        {!image && <div className='rectangular-cover'>
            <ImageHolder text={text}/>
        </div>}

        {blocked && <span className="image-box-blocked clr-red">
             <CancelIcon big/>
        </span>}

        {category && <span className="image-box-category">{category}</span>}

    </div>
};